export default __webpack_public_path__ + "static/media/MobileScan.debcfba0.svg";